import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=8ed1d042&scoped=true"
import script from "./MyCourses.vue?vue&type=script&lang=ts"
export * from "./MyCourses.vue?vue&type=script&lang=ts"
import style0 from "./MyCourses.vue?vue&type=style&index=0&id=8ed1d042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed1d042",
  null
  
)

export default component.exports